<template>
  <div
    class="bg-white rounded box-shadow p-3 mb-1"
    style="padding-bottom:1px!important"
  >
    <div class="row">
      <div
        v-if="show"
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
      >
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br />
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <h5 class="float-left">5.1 Structure Information</h5>
      </div>
      <div class="col float-right">
        <b-button
          v-b-modal.structure-modal
          type="button"
          class="btn btn-success float-right btn-sm mb-1 text-black float-right"
          @click="$bvModal.show('structure-modal'), getPersonLands(), resetForm()"
        >
          Add Structure
          <i class="fas fa-plus"></i>
        </b-button>
      </div>
    </div>

    <div class="scrollable-table">
      <table
        class="table table-bordered table-hover dt-table table-striped table-long table-sm "
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Stru ID</th>
            <th>Land Info</th>
            <th>Use of Structure</th>
            <th>Structure Description</th>
            <th>Lenght</th>
            <th>Width</th>
            <th>Height</th>
            <th>Unit</th>
            <th>Quantity</th>
            <th>Owner Conduct</th>
            <th>LA Case</th>
            <th>CCL Amount</th>
            <th>Book/Sub Book</th>
            <th>Cheque No.</th>
            <th>Cheque Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr li v-for="(structure, index) in structures" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <b>{{ structure.id }}</b>
            </td>
            <td>
              LnadID : <b>{{ structure.land_id }}</b>
            </td>
            <td>{{ structure.stru_uses.desc }}</td>
            <td>{{ structure.stru_desc.desc }}</td>
            <td>{{ structure.length }}</td>
            <td>{{ structure.width }}</td>
            <td>{{ structure.height }}</td>
            <td>{{ structure.unit.desc }}</td>
            <td>{{ structure.quantity_num }}</td>
            <td>{{ structure.owner_conduct.desc }}</td>
            <td>{{ structure.la_case }}</td>
            <td>{{ structure.ccl_amount }}</td>
            <td>{{ structure.book_no }}/{{ structure.book_sub_no }}</td>
            <td>{{ structure.cheque_no }}</td>
            <td>{{ structure.cheque_date }}</td>
            <td>
              <b-button
                size="sm"
                variant="warning"
                class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                @click.prevent="
                  editStructureodal(structure.id),
                    getPersonLands(),
                    $bvModal.show('structure-modal')
                "
              >
                <i class="far fa-edit"></i>
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                class="btn btn-warning btn-xs waves-effect waves-light"
                @click.prevent="softDelete(structure.id)"
              >
                <i class="far fa-trash-alt"></i>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>

      <modal-create-structure
        :structure="structure"
        :cclShow="cclShow"
        :btn_edit="btn_edit"
        :lands="lands"
        @cclShowUpdate="cclShowUpdate"
        @getPersonStructures="getPersonStructures"
        @resetForm="resetForm"
      ></modal-create-structure>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import ModalCreateStructure from "../../modals/ModalCreateStructure";

import appConfig from "@src/app.config";
import http from "@state/http";

export default {
  name: "structure-component",
  props: [],
  page: {
    title: "Fill up SES Form/Structure"
  },
  components: { Datepicker, ModalCreateStructure },
  data() {
    return {
      lands: [],
      structures: [],
      owner_conducts: [],
      stru_desc: [],
      stru_uses: [],
      units: [],
      upazillas: [],
      structure: {},
      cclShow: true,
      modalTitle: "",
      btn_edit: false,
      validation_errors: {},
      structure_id: false,
      landChk: false,
      show: false,
    };
  },

  methods: {
    cclShowUpdate(value) {
      this.cclShow = value;
    },

    desToUnit(DesId) {
      this.structure.c_unit_id = this.stru_desc[DesId - 1].c_unit_id;
    },
    resetForm() {
      this.btn_edit = false;
      this.structure = {};
    },
    editStructureodal(id) {
      this.btn_edit = true;
      http.get("api/ses/structures/" + id + "/edit").then(response => {
        if (!response.data.error) {
          this.structure = response.data.structure;
          this.structure.land_id = response.data.structure.land_stru.id;
          response.data.structure.land_stru.c_land_ownership_id == 1
            ? (this.cclShow = false)
            : (this.cclShow = true);
        }
      });
    },
    softDelete(struId) {
      http.delete("api/ses/structures/" + struId).then(response => {
        if (!response.error) {
          this.$bvToast.toast(response.data.message, {
            title: "Success",
            autoHideDelay: 5000,
            variant: "info"
          });
          this.getPersonStructures();
        }
      });
    },

    getPersonStructures() {
      http
        .post("api/ses/structure/personStructures/" + this.$route.params.ses_id)
        .then(response => {
          if (!response.error) {
            this.structures = response.data.structure;
          }
        });
    },
    getPersonLands() {
      http
        .get("api/ses/land/person-lands/" + this.$route.params.ses_id)
        .then(response => {
          if (!response.error) {
            this.lands = response.data.land;
          }
        });
    }
  },

  mounted() {
    this.structure.ses_id = this.$route.params.ses_id;
    this.getPersonStructures();
  }
};
</script>
